import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['all', 'checkbox']

  declare readonly allTargets: HTMLInputElement[]
  declare readonly checkboxTargets: HTMLInputElement[]

  connect (): void {
    this.allTargets.forEach((all) => { all.checked = this.allAreChecked(all.dataset.rolesSelectAllNameParam) })
  }

  toggle ({ target, params: { name } }: { target: HTMLInputElement, params: { name: string } }): void {
    this.filteredCheckboxTargets(name).forEach((checkbox) => { checkbox.checked = target.checked })
  }

  update ({ target }: { target: HTMLInputElement }): void {
    if (this.allTargets.length === 0) return

    const name = this.allTargets.length === 1 ? undefined : target.name
    const all = this.allTargets.length === 1 ? this.allTargets[0] : this.allTargets.find((checkbox) => checkbox.dataset.rolesSelectAllNameParam === name)

    if (all === undefined) return

    all.checked = this.allAreChecked(name)
  }

  private filteredCheckboxTargets (name?: string): HTMLInputElement[] {
    if (name === undefined) return this.checkboxTargets

    return this.checkboxTargets.filter((checkbox) => checkbox.name === name)
  }

  private allAreChecked (name?: string): boolean {
    const checkboxes = this.filteredCheckboxTargets(name)
    if (checkboxes.length === 0) return false

    return !checkboxes.some((checkbox) => !checkbox.checked)
  }
}
